import script from "./LearningFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./LearningFeatures.vue?vue&type=script&setup=true&lang=js"

import "./LearningFeatures.vue?vue&type=style&index=0&id=ee333c62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee333c62"]])

export default __exports__